var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationRolesLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72px",
    height: "73px",
    viewBox: "0 0 72 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M4.041 50.04h24.33a3.04 3.04 0 0 1 3.04 3.041v15.206a3.042 3.042 0 0 1-3.04 3.041H4.04A3.042 3.042 0 0 1 1 68.287V53.081a3.04 3.04 0 0 1 3.041-3.041zM67.906 71.328h-24.33a3.04 3.04 0 0 1-3.04-3.041V34.834a3.038 3.038 0 0 1 3.04-3.041h24.33a3.038 3.038 0 0 1 3.04 3.041v33.453a3.04 3.04 0 0 1-3.04 3.041zM67.906 22.668h-24.33a3.04 3.04 0 0 1-3.04-3.041V4.42a3.04 3.04 0 0 1 3.04-3.041h24.33a3.04 3.04 0 0 1 3.04 3.041v15.206a3.04 3.04 0 0 1-3.04 3.041z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF0F3",
    strokeLinejoin: "round",
    d: "M4.041 1.38h24.33a3.042 3.042 0 0 1 3.04 3.041v33.453a3.042 3.042 0 0 1-3.04 3.041H4.04A3.042 3.042 0 0 1 1 37.874V4.42A3.042 3.042 0 0 1 4.041 1.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 39h13M47 46h10"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationRolesLarge);
export default __webpack_public_path__ + "static/media/application-roles-large.68ad8369.svg";
export { ForwardRef as ReactComponent };